exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/confirmation-dialog/confirmation-dialog.component.css
// module id = ../../../../../src/app/component/confirmation-dialog/confirmation-dialog.component.css
// module chunks = main